function TrainNumbersListController($uibModal) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.sortType = 'number';
    ctrl.sortReverse = false; 
  };

  ctrl.toggleEditMode = ($event, trainNumber) => {
    $event.preventDefault();
    $event.stopPropagation();
    ctrl.editMode = true;
    ctrl.onToggle({
      $event: {
        editMode: true,
        trainNumber: trainNumber,
      },
    });
  };

  ctrl.openDeleteModal = ($event, trainNumber) => {
    $event.preventDefault();
    $event.stopPropagation();
    trainNumber.options = ctrl.modalOptions;
    let modalInstance = $uibModal.open({
      component: 'deleteModal',
      backdrop: 'static',
      resolve: {
        item: function() {
          return trainNumber;
        },
      },
    });

    modalInstance.result.then(
      trainNumberId => {
        // User pressed 'Yes' in the modal.
        ctrl.onDelete({
          $event: {
            trainNumberId: trainNumberId,
          },
        });
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.setSortType = column => {
    ctrl.sortType = column;
    ctrl.sortReverse = !ctrl.sortReverse;
  };
}

angular
  .module('pis-tool.module')
  .controller('TrainNumbersListController', TrainNumbersListController);
